import { ActionTypes as types } from '../../constants';
import { Dispatch } from 'redux';

export default (isToastOff: boolean) => (dispatch: Dispatch) => {
  dispatch({
    type: types.HIDE_SUCCESS_TOAST,
    payload: isToastOff,
  });
};
